import { useEffect } from "react";
import { SketchPicker } from "react-color";
import Select from "./Select";
import useEditorPanelButtonStore from "../../../store/useEditorPanelButtonStore";
import useObjectEditStore from "../../../store/useObjectEditStore";

const ColorPicker = () => {
  const store = useEditorPanelButtonStore();
  const objectEditStore = useObjectEditStore();

  useEffect(() => {
    if (store.isOpenModal !== 'color') {
      const colorFind = store.colors.findIndex((value) => value === objectEditStore.fontColor)
      if (colorFind === -1)
        store.setColors([...store.colors, objectEditStore.fontColor])
    }
  }, [store.isOpenModal])

  useEffect(() => {
    if (store.isOpenModal === 'color') {
      const objectEdit = () => {
        if (objectEditStore.objectEdit.element) {
          objectEditStore.objectEdit.element.style.color = objectEditStore.fontColor;
          return {
            ...objectEditStore.objectEdit,
            color: objectEditStore.fontColor,
          };
        }
        return objectEditStore.objectEdit
      }
      objectEditStore.setObjectEdit(objectEdit());
    }
  }, [objectEditStore.fontColor])

  return (
    <Select tab='color' buttonContent={<span className="color-picker__text">Color</span>}>
      <div className={`color-picker__list-block ${store.isOpenModal !== 'color' ? 'color-picker__list-hide' : ''}`}>
        <SketchPicker color={ objectEditStore.fontColor } presetColors={store.colors}
                      onChange={ (currentColor) => objectEditStore.setFontColor(currentColor.hex) }/>
      </div>
    </Select>
  );
};

export default ColorPicker;
